export default {
    updateUrl(state, payload) {
        state.url = payload;
    },

    updateVideoData(state, payload) {
        Object.assign(state.videoData, payload);
    },

    resetVideoData(state) {
        Object.assign(state.videoData, {
            code: null,
            image: null,
            title: null
        });
    },

    setIsLoading(state, payload) {
        state.isLoading = payload;
    }
}